import Vue from "vue";
import App from "./App";
import router from "./router/index";

import PsicodelicPinky from "./plugins/psicodelicPinky";

Vue.use(PsicodelicPinky);

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
